import Direction from '@/directions/Direction'
import KeyValuePair from '@/interfaces/KeyValuePair'
import { Terminal } from '@/models/Terminal'
import { TerminalSrsLocation } from '@/models/TerminalSrsLocation'

export default class FacilityDirection implements Direction {
	public text!: string
	public color!: string
	public icon!: string
	public coordinates!: string

	public facilityId!: string
	public facilityType!: string

	public getQueryParameters(index: number = 0): Array<KeyValuePair> {
		return [
			{
				key: `locations[${index}][facilityId]`,
				value: this.facilityId
			},
			{
				key: `locations[${index}][facilityType]`,
				value: this.facilityType
			}
		]
	}

	public static fromTerminal(terminal: Terminal): FacilityDirection {
		const direction = new FacilityDirection()
		direction.facilityId = terminal.getApiId() as string
		direction.facilityType = 'terminals'
		direction.text = terminal.getName()
		return direction
	}

	public static fromTerminalSrsLocation(terminalSrsLocation: TerminalSrsLocation): FacilityDirection {
		const direction = new FacilityDirection()
		direction.facilityId = terminalSrsLocation.getApiId() as string
		direction.facilityType = 'terminalSrsLocations'
		direction.text = terminalSrsLocation.getName()
		return direction
	}
}
